import { ExpressCheckoutPaymentMethodsOption } from '@stripe/stripe-js';

import { EStripePaymentMethods } from '../../../../contracts';

export const getPaymentMethodsConfig = (
  showGoogle: boolean,
  showApple: boolean,
  showLink: boolean,
  exclusivePaymentMethod?: EStripePaymentMethods
) => {
  if (exclusivePaymentMethod) {
    return {
      googlePay: (exclusivePaymentMethod === EStripePaymentMethods.google
        ? 'always'
        : 'never') as ExpressCheckoutPaymentMethodsOption['googlePay'],
      applePay: (exclusivePaymentMethod === EStripePaymentMethods.apple
        ? 'always'
        : 'never') as ExpressCheckoutPaymentMethodsOption['applePay'],
      link:
        exclusivePaymentMethod === EStripePaymentMethods.link
          ? 'auto'
          : ('never' as ExpressCheckoutPaymentMethodsOption['link']),
    };
  }
  return {
    googlePay: (showGoogle
      ? 'always'
      : 'never') as ExpressCheckoutPaymentMethodsOption['googlePay'],
    applePay: (showApple ? 'always' : 'never') as ExpressCheckoutPaymentMethodsOption['applePay'],
    link: showLink ? 'auto' : ('never' as ExpressCheckoutPaymentMethodsOption['link']),
  };
};
